export const DELETE = 'Delete';
export const CLONE = 'Clone';
export const NA = 'n/a';
export const NUMBER_ROUND_DECIMAL = 3;
